import { SELECT_EMPTY } from "../consts";

export const sampleFunction = () => { };

export const getLocalStorageItem = (key: string) => {
    const item: any = window.localStorage.getItem(key);
    return item !== 'undefined' ? JSON.parse(item) : null;
};

export const setILocalStorageItem = (key: string, value: any) => {
    window.localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorageItem = (key: string) => {
    window.localStorage.removeItem(key);
};

export const getApiBaseUrl = () => {
    return process.env.REACT_APP_API_URL;
};

export function isObject(item: any) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

export default function deepmerge(target: any, source: any, options: any = { clone: true }) {
    const output: any = options.clone ? { ...target } : target;

    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (key === '__proto__') {
                return;
            }

            if (isObject(source[key]) && key in target) {
                output[key] = deepmerge(target[key], source[key], options);
            } else {
                output[key] = source[key];
            }
        });
    }

    return output;
}

export const IsNullOrEmpty = (val: string | null | undefined): boolean => {
    return val === null || val === "" || val === undefined;

}

export const GetSplitPhoneNumber = (val: string | null | undefined): string => {
    var splitter='';
    var splitted=[];
    var phone='';
    if( val === null || val === "" || val === undefined)
    {
      return '';
    }
    if(val.length===14)//(**/****/*******)
    {
        splitter=val.substring(2,3);
        splitted=val.split(splitter);
        for (let i = 0; i < splitted.length; i++) 
        {
            if(i===0)continue;
            phone=phone+splitted[i];
        }
    }
    if(val.length===12)//(************)
     {
        phone=val.substring(2);
     }
     if(val.length===10)phone=val;
    return phone;

}

export const IsNullOrZero = (val: number | null | undefined): boolean => {
    return val === null || val === 0 || val === undefined;
}

export const IsValidTckn = (val: string | null | undefined): boolean => {
    return /^[1-9]{1}[0-9]{9}[02468]{1}$/.test(val ?? '');
}

export const IsOnlyLetters = (val: string) => {
    return /^[A-Za-zşŞıİçÇöÖüÜĞğ\s]+$/g.test(val);
}

export const IsValidEmail = (val: string) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val);
}

export const IsSelectEmpty = (val: any): boolean => {
    return val === null || val === SELECT_EMPTY;
}

export const ClearNonNumberChars = (val: string): string => {
    return val.replace(/\D/g, '');
}

export const ParseDate = (val: string | null | undefined) => {
    if (val) {
        const [day, month, year] = val.split('.');
        return new Date(+year, +month - 1, +day);
    }
    return val === undefined ? null : val;
}

export const ParseDateTime = (val: string | null | undefined) => {
    if (val) {
        const [dateValues, timeValues] = val.split(' ');
        const [day, month, year] = dateValues.split('.');
        const [hours, minutes, seconds] = timeValues.split(':');
        return new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
    }
    return val === undefined ? null : val;
}
